import type { BatchOMap, KeyPath, SourceObject } from "./dto";

/**
 * 按键序列取值
 * @param obj 原对象
 * @param keys 键序列
 * @returns value
 */
export function getDeepValue(
  obj: SourceObject,
  keys: KeyPath
): any | undefined {
  if (Array.isArray(keys)) {
    let current: SourceObject | any = obj;

    for (const key of keys) {
      if (typeof current === "object" && current !== null && key in current) {
        current = current[key];
      } else {
        return undefined;
      }
    }
    return current;
  } else {
    return obj[keys];
  }
}
/** 按键序列删除值 */
export function deleteDeepValue(obj: SourceObject, keys: KeyPath) {
  if (Array.isArray(keys)) {
    let current = obj;
    if (keys.length === 1) {
      delete current[keys[0]];
      return;
    }
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      //如果进入数组索引，则删除此数组元素而不是值
      if (typeof key === "number" && i === keys.length - 2) {
        current[key] = null;
        return;
      } else if (i === keys.length - 1) {
        delete current[key];
        return;
      } else {
        current = current[key];
      }
    }
  } else {
    delete obj[keys];
  }
}
/**
 * 按键序列创建值
 * @param keys 键序列
 * @param value 值
 * @returns obj
 */
export function createDeepValue(keys: KeyPath, value: any) {
  const obj: SourceObject = {};
  let current = obj;
  if (Array.isArray(keys)) {
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const nextKey = keys[i + 1];
      if (typeof key === "string" && typeof nextKey === "number") {
        current[key] = [];
      } else {
        current[key] = {};
      }

      if (i < keys.length - 1) {
        current = current[key];
      } else {
        current[key] = value;
      }
    }
  } else {
    current[keys] = value;
  }

  return obj;
}

/**
 * 按键序列更新值
 * @param keys 键序列
 * @param value 值
 * @returns
 */
export function updateDeepValue<T>(
  obj: SourceObject,
  keys: KeyPath,
  value: any,
  initV: T
) {
  let current = obj;

  if (Array.isArray(keys)) {
    if (keys.length === 1) {
      current[keys[0]] = value;
      return;
    } else {
      for (let i = 0; i < keys.length; i++) {
        const k = keys[i];

        if (i < keys.length - 1) {
          if (current[k] === null) {
            current[k] = getDeepValue(initV, keys.slice(0, i + 1));
          }
          current = current[k];
        } else {
          current[k] = value;
        }
      }
    }
  } else {
    current[keys] = value;
  }
}

/**
 * 批量更新值
 * @param obj 源对象
 * @param t 需要更新的值
 * @returns
 */
export function batchUpdateDeepValue<T>(
  obj: SourceObject,
  t: BatchOMap,
  initV: T
) {
  if (!t) return;
  for (const key of t.keys()) {
    updateDeepValue<T>(obj, key, t.get(key), initV);
  }
}
